// src/store/clearAllStores.ts
import { useUserStore } from "./userStore";
import { useCartStore } from "./cartStore";
import { useMasterBriefStore } from "./masterBriefStore";
import { useMasterStatusStore } from "./masterStatusStore";

export function clearAllStores() {
  try { useCartStore.getState().clear?.(); } catch {}
  try { useMasterBriefStore.getState().clear?.(); } catch {}
  try { useMasterStatusStore.getState().clear?.(); } catch {}

  // userStore may not have a clear(), so hard-reset common fields safely
  try {
    const reset = (useUserStore.getState() as any)?.clear ?? (useUserStore.getState() as any)?.logout;
    if (typeof reset === "function") reset();
    else {
      useUserStore.setState({
        accessToken: null,
        refreshToken: null,
        token: null,
        user: null,
        currentOEM: null,
      } as any);
    }
  } catch {}
}
